import { FileType } from '../../../lib/types/models/file/file'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterProgramDocuments(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterProgramDocuments.url, { id }))
    .get<FileType[]>()
}
